import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { p as parseHrefProp } from './index10.js';
import { d as defineCustomElement$1 } from './icon.js';

const hyperlinkCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;border-radius:.125rem;box-sizing:border-box;cursor:pointer;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;max-width:fit-content}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host a{align-items:center;color:inherit;display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:600;gap:.25rem;letter-spacing:-.0004em;line-height:1.25rem;overflow:hidden;text-decoration:underline;text-overflow:ellipsis;white-space:nowrap}:host([type=regular]){color:var(--jw-theme-system-secondary-default-color)}:host([type=regular]:not([disabled]):hover){color:var(--jw-theme-system-secondary-hover-color)}:host([type=regular]:not([disabled]):active){color:var(--jw-theme-system-secondary-active-color)}:host([type=inverted]){color:var(--jw-theme-surface-bold-link-inverted-default-color)}:host([type=inverted]:not([disabled]):hover){color:var(--jw-theme-surface-bold-link-inverted-hover-color)}:host([type=inverted]:not([disabled]):active){color:var(--jw-theme-surface-bold-link-inverted-active-color)}:host(:not([disabled]):focus){outline:var(--jw-theme-effects-focus-default-outline)}:host([disabled]){cursor:not-allowed}";
const WuiHyperlinkStyle0 = hyperlinkCss;

const WuiHyperlink = /*@__PURE__*/ proxyCustomElement(class WuiHyperlink extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.type = 'regular';
        this.label = 'Link';
        this.href = undefined;
        this.leadingIcon = undefined;
        this.trailingIcon = undefined;
        this.disabled = undefined;
    }
    render() {
        const parsedHrefProps = parseHrefProp(this.href, this.disabled);
        const isExternalLink = parsedHrefProps.href &&
            (parsedHrefProps.href.startsWith('http://') || parsedHrefProps.href.startsWith('https://'));
        const trailingIcon = isExternalLink ? 'external-link' : this.trailingIcon;
        return (h(Host, { key: '577ee51af941b37a6077aeb43c83f275bdd20250' }, h("a", { key: '42210e31324de2aa604ca1245a7489bf9527242b', ...parsedHrefProps }, this.leadingIcon && h("wui-icon", { key: '93369ed0363c3ad5a077143228065d42197c4d28', name: this.leadingIcon }), this.label, trailingIcon && h("wui-icon", { key: '939cc5fa3b31ba45c19691b7d108a81b36b96f0e', name: trailingIcon }))));
    }
    static get style() { return WuiHyperlinkStyle0; }
}, [1, "wui-hyperlink", {
        "type": [513],
        "label": [1],
        "href": [1],
        "leadingIcon": [1, "leading-icon"],
        "trailingIcon": [1, "trailing-icon"],
        "disabled": [516]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-hyperlink", "wui-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-hyperlink":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiHyperlink);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiHyperlink as W, defineCustomElement as d };

//# sourceMappingURL=hyperlink.js.map